/*jshint esversion: 9 */
// import { mapGetters, mapActions } from 'vuex';
import * as THREE from 'three';

export const IfcSectionsMixin = {
  components: {
  },
  data: () => ({
    backFaceStencilMat: {},
    frontFaceStencilMat: {},
    planeStencilMat: {},
    stencilWriteMeshesGroup: {},
    stencilPlaneGroup_hor: {},
    stencilPlaneGroup_ver_x: {},
    stencilPlaneGroup_ver_y: {},
    stencilPlanes_hor: [],
    stencilPlanes_ver_x: [],
    stencilPlanes_ver_y: [],
    test_int: 1,
    show_clip_caps: false,
    flip_normals: false,
    colors: [
      'red', 'green', 'blue', 'yellow', 'pink', 'grey', 'black', 'white', 'coral', 'DarkOrchid', 'gold', 'LightPink', 'olive',
    ]
  }),
  mounted() {
  },
  watch: {
    show_section_hor(val) {
      if (val) {
        this.addClippingPlane('hor');
      } else {
        this.removeClippingPlane('hor')
      }
    },
    show_section_ver_x(val) {
      if (val) {
        this.addClippingPlane('ver_x');
      } else {
        this.removeClippingPlane('ver_x')
      }
    },
    show_section_ver_y(val) {
      if (val) {
        this.addClippingPlane('ver_y');
      } else {
        this.removeClippingPlane('ver_y')
      }
    },
    show_clip_caps(val) {
      this.clipping_planes.forEach(plane => {
        if (val) {
            this.startStencil(plane.type);
          } else {
            this.endStencil(plane.type);
          }
      });
    },
    flip_normals() {
      this.stencilWriteMeshes.forEach(mesh => {
        if (mesh.material.side === 1) {
          mesh.material.side = 0;
        } else {
          mesh.material.side = 1;
        }
      })
    }
  },
  // computed: {

  // },
  methods: {
    initializeClipping() {
      console.log('init clip');
    this.clipping_plane_hor = new THREE.Plane();
    this.clipping_plane_hor.name = 'clipping_plane_hor';
    this.clipping_plane_hor.normal.set( 0, 0, this.invert_section_hor?1:-1);
    this.clipping_plane_hor.constant = 1;
    this.clipping_plane_hor.type = 'hor';

    this.clipping_plane_ver_x = new THREE.Plane();
    this.clipping_plane_ver_x.name = 'clipping_plane_ver_x';
    this.clipping_plane_ver_x.normal.set( 0, this.invert_section_ver_x?1:-1, 0);
    this.clipping_plane_ver_x.constant = 1;
    this.clipping_plane_ver_x.type = 'ver_x';

    this.clipping_plane_ver_y = new THREE.Plane();
    this.clipping_plane_ver_y.name = 'clipping_plane_ver_y';
    this.clipping_plane_ver_y.normal.set( this.invert_section_ver_y?1:-1, 0, 0);
    this.clipping_plane_ver_y.constant = 1;
    this.clipping_plane_ver_y.type = 'ver_y';
    

    // // initialize stencil planes
    // this.stencilGroup = new THREE.Group();
    // this.stencilGroup.name = "stencilGroup";
    // this.stencilGroup.position.y = this.clipping_plane_hor.constant;
    // this.stencilPlaneGroup.rotateX( Math.PI / 2);

    // Write Meshes
    this.stencilWriteMeshesGroup = new THREE.Group();
    this.stencilWriteMeshesGroup.name = "stencilWriteMeshesGroup";
    // Hor
    this.stencilPlaneGroup_hor = new THREE.Group();
    this.stencilPlaneGroup_hor.name = "stencilPlaneGroup_hor";
    this.stencilPlaneGroup_hor.position.z = 1;
    // Ver X
    this.stencilPlaneGroup_ver_x = new THREE.Group();
    this.stencilPlaneGroup_ver_x.name = "stencilPlaneGroup_ver_x";
    this.stencilPlaneGroup_ver_x.position.y = 1;
    // Ver Y
    this.stencilPlaneGroup_ver_y = new THREE.Group();
    this.stencilPlaneGroup_ver_y.name = "stencilPlaneGroup_ver_y";
    this.stencilPlaneGroup_ver_y.position.x = 1;


    // add meshes to groups
    for (let i = 0; i < this.visible_normal_group.children.length; i++) {
      // this.stencilPlaneGroup.add(this.createStencilPlaneMesh(i));
      let mesh = this.visible_normal_group.children[i];
      this.createStencilPlaneMeshes(i, mesh);
    }

    this.stencilWriteMeshes.forEach(mesh => {
      this.stencilWriteMeshesGroup.add(mesh);
    });
    // console.log(this.stencilWriteMeshesGroup);
    // this.stencilPlanes.forEach(plane => {
    //   this.stencilPlaneGroup_hor.add(plane);
    // });
    // this.stencilPlanes.forEach(plane => {
    //   this.stencilPlaneGroup_ver_x.add(plane);
    // });
    // this.stencilPlanes.forEach(plane => {
    //   this.stencilPlaneGroup_ver_y.add(plane);
    // });

    // this.all_groups.traverse( el => {
    //   if (el.material) {
    //     el.material.clippingPlanes = this.clipping_planes;
    //   }
    // });

        //   let planeMesh = new THREE.Mesh( new THREE.PlaneBufferGeometry(), new THREE.MeshBasicMaterial( {
    //     side: THREE.DoubleSide,
    //     stencilWrite: true,
    //     stencilFunc: THREE.NotEqualStencilFunc,
    //     stencilFail: THREE.ZeroStencilOp,
    //     stencilZFail: THREE.ZeroStencilOp,
    //     stencilZPass: THREE.ZeroStencilOp,
    //   } ) );
    //   planeMesh.scale.setScalar( 1.5 );
    //   planeMesh.material.color.set( 0x80deea ).convertLinearToSRGB();
    //   planeMesh.renderOrder = 2;
    //   this.scene.add( planeMesh );


  },
  addClippingPlane(type) {
    this.clipping_planes.push(this[`clipping_plane_${type}`]);
    // add stencils
    if (this.show_clip_caps) {
      this.startStencil(type);
    }
  },
  removeClippingPlane(type) {
    let index = this.clipping_planes.indexOf(el => el.name = `clipping_plane_${type}`);
    this.clipping_planes.splice(index, 1);
    if (this.show_clip_caps) {
      this.endStencil(type);
    }
  },
  setClippingPlaneHor(height) {
    // this.clipping_plane_hor.constant = parseFloat(height) + this.center_position.y;
    this.clipping_plane_hor.constant = parseFloat(height);
    this.stencilPlaneGroup_hor.position.z = parseFloat(height);
  },

  setClippingPlaneVertX(height) {
    // this.clipping_plane_ver_x.constant = parseFloat(height) + this.center_position.z;
    this.clipping_plane_ver_x.constant = parseFloat(height);
    this.stencilPlaneGroup_ver_x.position.y = parseFloat(height);

  },

  setClippingPlaneVertY(height) {
    // this.clipping_plane_ver_y.constant = parseFloat(height) + this.center_position.x;
    this.clipping_plane_ver_y.constant = parseFloat(height);
    this.stencilPlaneGroup_ver_y.position.x = parseFloat(height);
  },

  createStencilPlaneMeshes(mesh_index, mesh) { //initialize mesh for on which clips caps are calculated through stencil
    let plane_material = new THREE.MeshBasicMaterial( {
      side: THREE.DoubleSide,

      stencilWrite: true,

      // stencilRef: 1,
      // stencilFunc: THREE.EqualStencilFunc,
      // stencilFail: THREE.ReplaceStencilOp,
      // stencilZFail: THREE.ReplaceStencilOp,
      // stencilZPass: THREE.ReplaceStencilOp,

      stencilRef: 1,
      stencilFunc: THREE.EqualStencilFunc,
      stencilFail: THREE.ZeroStencilOp,
      stencilZFail: THREE.ZeroStencilOp,
      stencilZPass: THREE.ZeroStencilOp,


      // stencilWrite: true,
      // depthWrite: false,
      // stencilRef: 1,
      // // stencilFunc: THREE.NotEqualStencilFunc,
      // // stencilFail: THREE.ZeroStencilOp,
      // // stencilZFail: THREE.ZeroStencilOp,
      // // stencilZPass: THREE.ZeroStencilOp,
      // // stencilFunc: THREE.AlwaysStencilFunc,
      // stencilFunc: THREE.EqualStencilFunc,
      // // stencilFail: THREE.ReplaceStencilOp,
      // // stencilZFail: THREE.ReplaceStencilOp,
      // // stencilZPass: THREE.ReplaceStencilOp,
      // // stencilFuncMask: this.test_int.toString(16),
    } );
    let planeMesh_hor = new THREE.Mesh( new THREE.PlaneBufferGeometry(), plane_material);
    let box = new THREE.Box3().setFromObject( this.visible_normal_group, true );
    // planeMesh_hor.scale.setScalar( 100 );
    // set plane dimensions
    let pos_arr = planeMesh_hor.geometry.attributes.position.array;
    pos_arr[0] = box.min.x-1;
    pos_arr[1] = (box.max.z+1)*-1;

    pos_arr[3] = box.max.x+1;
    pos_arr[4] = (box.max.z+1)*-1;

    pos_arr[6] = box.min.x-1;
    pos_arr[7] = (box.min.z-1)*-1;

    pos_arr[9] = box.max.x+1;
    pos_arr[10] = (box.min.z-1)*-1;

    // planeMesh_hor.material.color.set( this.colors[mesh_index] );
    planeMesh_hor.material.color = mesh.material.color;
    planeMesh_hor.renderOrder = (mesh_index+1) * 10 + 2;

    // planeMesh_hor.rotateX( Math.PI / 2);
    // planeMesh_hor.translateZ(-1); 
    planeMesh_hor.name = `stencilPlane_hor_${mesh.name}`;
    this.stencilPlaneGroup_hor.add(planeMesh_hor);

    // ver_x
    let planeMesh_ver_x = new THREE.Mesh( new THREE.PlaneBufferGeometry(), plane_material);
    // set plane dimensions
    pos_arr = planeMesh_ver_x.geometry.attributes.position.array;
    pos_arr[0] = box.min.x-1;
    pos_arr[1] = box.max.y+1;

    pos_arr[3] = box.max.x+1;
    pos_arr[4] = box.max.y+1;

    pos_arr[6] = box.min.x-1;
    pos_arr[7] = box.min.y-1;

    pos_arr[9] = box.max.x+1;
    pos_arr[10] = box.min.y-1;

    planeMesh_ver_x.material.color = mesh.material.color;
    planeMesh_ver_x.renderOrder = (mesh_index+1) * 10 + 2;

    planeMesh_ver_x.rotateX(  Math.PI / 2);
    planeMesh_ver_x.name = `stencilPlane_ver_x_${mesh.name}`;
    this.stencilPlaneGroup_ver_x.add(planeMesh_ver_x);

    // ver_y
    let planeMesh_ver_y = new THREE.Mesh( new THREE.PlaneBufferGeometry(), plane_material);
    // set plane dimensions
    let pos_arr3 = planeMesh_ver_y.geometry.attributes.position.array;
    pos_arr3[0] = box.min.z-1;
    pos_arr3[1] = (box.max.y+1)*-1;

    pos_arr3[3] = box.max.z+1;
    pos_arr3[4] = (box.max.y+1)*-1;

    pos_arr3[6] = box.min.z-1;
    pos_arr3[7] = (box.min.y-1)*-1;

    pos_arr3[9] = box.max.z+1;
    pos_arr3[10] = (box.min.y-1)*-1;

    planeMesh_ver_y.material.color = mesh.material.color;
    planeMesh_ver_y.renderOrder = (mesh_index+1) * 10 + 2;

    planeMesh_ver_y.rotateX( - Math.PI / 2);
    planeMesh_ver_y.rotateY( Math.PI / 2);
    planeMesh_ver_y.name = `stencilPlane_ver_y_${mesh.name}`;
    this.stencilPlaneGroup_ver_y.add(planeMesh_ver_y);

    // this.all_groups.add( planeMesh );
    // return planeMesh;
  },
  startStencil(type) {
    let writeMeshesGroup = this.all_groups.getObjectByName('stencilWriteMeshesGroup');
    if (!writeMeshesGroup) {
      this.all_groups.add(this.stencilWriteMeshesGroup);
    }
    this.scene.add(this[`stencilPlaneGroup_${type}`]);
    // console.log(this.scene);
  },
  endStencil(type) {
    let planesGroup = this.scene.getObjectByName(`stencilPlaneGroup_${type}`);
    this.scene.remove(planesGroup); //are these really good released?
    let writeMeshesGroup = this.all_groups.getObjectByName('stencilWriteMeshesGroup');
    if (writeMeshesGroup) {
      this.all_groups.remove(writeMeshesGroup); //are these really good released?n 
    }
    // this.removeObjectByName('stencilPlaneGroup', this.all_groups);
    // this.removeObjectByName('stencilWriteMeshesGroup', this.all_groups);
  },
  initStencilMaterials() { //old not used but good for understanding whats happening in stencil, keep it
		// PASS 1
    // everywhere that the back faces are visible (clipped region) the stencil
    // buffer is incremented by 1.
		this.backFaceStencilMat = new THREE.MeshBasicMaterial();
    this.backFaceStencilMat.depthWrite = false;
    this.backFaceStencilMat.depthTest = false;
    this.backFaceStencilMat.colorWrite = false;
    this.backFaceStencilMat.stencilWrite = true;
    this.backFaceStencilMat.stencilFunc = THREE.AlwaysStencilFunc;
    this.backFaceStencilMat.side = THREE.BackSide;
    this.backFaceStencilMat.stencilFail = THREE.IncrementWrapStencilOp;
    this.backFaceStencilMat.stencilZFail = THREE.IncrementWrapStencilOp;
    this.backFaceStencilMat.stencilZPass = THREE.IncrementWrapStencilOp;

		// PASS 2
    // everywhere that the front faces are visible the stencil
    // buffer is decremented back to 0.
    this.frontFaceStencilMat = new THREE.MeshBasicMaterial();
    this.frontFaceStencilMat.depthWrite = false;
    this.frontFaceStencilMat.depthTest = false;
    this.frontFaceStencilMat.colorWrite = false;
    this.frontFaceStencilMat.stencilWrite = true;
    this.frontFaceStencilMat.stencilFunc = THREE.AlwaysStencilFunc;
    this.frontFaceStencilMat.side = THREE.FrontSide;
    this.frontFaceStencilMat.stencilFail = THREE.DecrementWrapStencilOp;
    this.frontFaceStencilMat.stencilZFail = THREE.DecrementWrapStencilOp;
    this.frontFaceStencilMat.stencilZPass = THREE.DecrementWrapStencilOp;

		// PASS 3
    // draw the plane everywhere that the stencil buffer != 0, which will
    // only be in the clipped region where back faces are visible.
    this.planeStencilMat = new THREE.MeshNormalMaterial();
		this.planeStencilMat.stencilWrite = true;
    this.planeStencilMat.stencilRef = 0;
    this.planeStencilMat.stencilFunc = THREE.NotEqualStencilFunc;
    this.planeStencilMat.stencilFail = THREE.ReplaceStencilOp;
    this.planeStencilMat.stencilZFail = THREE.ReplaceStencilOp;
    this.planeStencilMat.stencilZPass = THREE.ReplaceStencilOp;
}
}
}
